import { AppBar, Box, Button, Container, IconButton, Link, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, Outlet } from 'react-router-dom';
import { useState } from 'react';

const navLinks = [
  { label: 'Funzionalità', to: '/features' },
  { label: 'Prezzi', to: '/pricing' },
  { label: 'Contatti', to: '/contact' },
];

export function PublicLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="sticky" elevation={1} sx={{ backgroundColor: 'background.paper', color: 'text.primary' }}>
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          <Link component={RouterLink} to="/" underline="none" color="inherit" sx={{ fontWeight: 700, fontSize: '1.25rem' }}>
            Cantir
          </Link>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1, alignItems: 'center' }}>
            {navLinks.map(({ label, to }) => (
              <Link key={to} component={RouterLink} to={to} underline="hover" color="text.primary" sx={{ px: 1.5 }}>
                {label}
              </Link>
            ))}
            <Button component={RouterLink} to="/contact" variant="outlined" size="small" sx={{ ml: 1 }}>
              Richiedi demo
            </Button>
            <Button component={RouterLink} to="/login" variant="contained" size="small" sx={{ ml: 1 }}>
              Accedi
            </Button>
          </Box>
          <IconButton
            color="inherit"
            aria-label="menu"
            sx={{ display: { md: 'none' } }}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
        {mobileOpen && (
          <Box sx={{ display: { md: 'none' }, px: 2, pb: 2 }}>
            {navLinks.map(({ label, to }) => (
              <Link
                key={to}
                component={RouterLink}
                to={to}
                underline="hover"
                display="block"
                py={1}
                onClick={() => setMobileOpen(false)}
              >
                {label}
              </Link>
            ))}
            <Button component={RouterLink} to="/contact" variant="outlined" fullWidth sx={{ mt: 1 }} onClick={() => setMobileOpen(false)}>
              Richiedi demo
            </Button>
            <Button component={RouterLink} to="/login" variant="contained" fullWidth sx={{ mt: 1 }} onClick={() => setMobileOpen(false)}>
              Accedi
            </Button>
          </Box>
        )}
      </AppBar>

      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>

      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: 'grey.100',
          borderTop: 1,
          borderColor: 'divider',
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center', mb: 2 }}>
            <Link component={RouterLink} to="/privacy" underline="hover" color="text.secondary">
              Privacy
            </Link>
            <Link component={RouterLink} to="/terms" underline="hover" color="text.secondary">
              Termini
            </Link>
            <Link component={RouterLink} to="/contact" underline="hover" color="text.secondary">
              Contatti
            </Link>
            <Link component={RouterLink} to="/login" underline="hover" color="text.secondary">
              Accedi
            </Link>
          </Box>
          <Typography variant="body2" color="text.secondary" align="center">
            Cantir — Gestione cantieri e commesse
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 0.5 }}>
            © {new Date().getFullYear()} Cantir
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
